import React from 'react';
import { Alert, AlertProps } from '@mui/material';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';

interface SadAlertProps extends Omit<AlertProps, 'severity' | 'icon'> {}

export const SadAlert: React.FC<SadAlertProps> = ({ sx, children, ...props }) => {
  return (
    <Alert
      severity="error"
      sx={{
        mt: 2,
        mb: 2,
        border: '1px solid red',
        display: 'flex',
        alignItems: 'center',
        background: 'main.page',
        ...sx,
      }}
      icon={<SentimentVeryDissatisfiedIcon sx={{ verticalAlign: 'middle' }} />}
      {...props}
    >
      {children}
    </Alert>
  );
};

export default SadAlert;
